import './ProjectStatsSections.scss';
import { ReactElement } from 'react';
import { ExportProjectStatsButtonContainer } from './export/ui/ExportProjectStatsButton.container';
import { ProjectStatsFilters } from './filters/ui/ProjectStatsFilters';

export const ProjectStatsTopBar = (): ReactElement => (
  <div className='project-stats-top-bar'>
    <ProjectStatsFilters />
    <ExportProjectStatsButtonContainer />
  </div>
);
